var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',_vm._g(_vm._b({attrs:{"background":"","layout":"total, sizes, prev, pager, next, jumper","page-sizes":_vm.sizes},on:{"current-change":_vm.currentChange,"size-change":_vm.sizeChange}},'el-pagination',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }